module.exports = __webpack_public_path__ + "img/classButton-2.e8de8909.png";